module.exports = __webpack_public_path__ + "static/media/spice.599323f0.jpg";